module.exports = __webpack_public_path__ + "img/exam3.0a1ac37b.png";